import queryString from 'query-string'
import { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import Overview from './Overview'
import Registration from './Registration'
import { GetStartedStepsContainer, TabItemContainer } from './style'

function GetStartedSteps() {
  const { t } = useTranslation()
  const location = useLocation()
  const { step } = queryString.parse(location.search)
  const [currentStep, setCurrentStep] = useState(step || 'overview')

  return (
    <GetStartedStepsContainer>
      <Tabs
        activeKey={currentStep}
        className="get-started-taps"
        id="uncontrolled-tab-example"
        onSelect={(eventKey) => setCurrentStep(eventKey)}
      >
        <Tab
          eventKey="overview"
          title={
            <TabItemContainer className="tab-item">
              <span className="tab-order">1</span>
              {t('started_steps_overview_title')}
            </TabItemContainer>
          }
        >
          <Overview onClickNext={() => setCurrentStep('registration')} />
        </Tab>
        <Tab
          eventKey="registration"
          title={
            <TabItemContainer className="tab-item">
              <div className="tab-order">2</div>
              {t('started_steps_registration_tab_title')}
            </TabItemContainer>
          }
        >
          <Registration setCurrentStep={setCurrentStep} />
        </Tab>
        <Tab
          eventKey="completed"
          title={
            <TabItemContainer className="tab-item">
              <div className="tab-order">3</div>
              {t('started_steps_completed_tab_title')}
            </TabItemContainer>
          }
          disabled={
            currentStep === 'overview' || currentStep === 'registration'
          }
        ></Tab>
      </Tabs>
    </GetStartedStepsContainer>
  )
}

export default GetStartedSteps
